__webpack_require__.p = "/shopping_app/";